<template>
    <sa-page-layout :btnBackVisible="false" :btnEditVisible="btnEditVisible" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <rsa-paziente-riepilogo-operatori-list-component ref="cmpRsaRiepilogoOperatoriList" :idAccettazione="idAccettazione" @onBeforeLoadData="onBeforeLoadData" @onAfterLoadData="onAfterLoadData"></rsa-paziente-riepilogo-operatori-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaPazienteRiepilogoOperatoriListComponent from "../components/RsaPazienteRiepilogoOperatoriListComponent.vue";
export default {
    components: { SaPageLayout, RsaPazienteRiepilogoOperatoriListComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "",
            btnEditVisible: false,
            showModalLoading: false,
            linkback: null,
            linkedit: null,
            idAccettazione: this.$route.query.idAccettazione || null,
        };
    },
    mounted() {
        let me = this;
        me.init();
    },
    methods: {
        init() {
            let me = this;
            me.$refs.cmpRsaRiepilogoOperatoriList.init(me.idAccettazione, false);
        },

        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>
<style></style>
